import { Tooltip } from '@mui/material';
import React from 'react';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import NoPhotographyIcon from '@mui/icons-material/NoPhotography';

type DeliveryImageTooltipProps = {
    imageBase64String: string;
    scanImageStatus: 'Passed' | 'Failed' | undefined;
    handleOnClick: (arg0: string) => void;
    hasAccessToAllPictures: boolean;
};

const getDeliveryImageIcon = (imageStatus: 'Passed' | 'Failed' | undefined, hasAccessToAllPictures: boolean) => {
    const onlyHasAccessToApprovedPictures = !hasAccessToAllPictures;
    const ICON_STYLE = { cursor: 'pointer' };

    if (onlyHasAccessToApprovedPictures && imageStatus === 'Passed') {
        return <PhotoCameraIcon color="primary" style={ICON_STYLE} />;
    }

    if (hasAccessToAllPictures) {
        switch (imageStatus) {
            case 'Passed':
                return <PhotoCameraIcon style={{ ...ICON_STYLE, color: 'green' }} />;
            case 'Failed':
                return <NoPhotographyIcon style={{ ...ICON_STYLE, color: 'red' }} />;
            default:
                return <PhotoCameraIcon color="primary" style={ICON_STYLE} />;
        }
    }
};

export const DeliveryImageTooltip = ({
    imageBase64String,
    scanImageStatus,
    handleOnClick,
    hasAccessToAllPictures,
}: DeliveryImageTooltipProps) => {
    return (
        <Tooltip
            title={
                <div className="image-tooltip-container">
                    <img
                        src={`data:image/jpeg;base64,${imageBase64String}`}
                        alt="Delivery"
                        className="delivery-picture-on-hover"
                    />
                </div>
            }
            placement="left"
            componentsProps={{
                tooltip: {
                    sx: {
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        padding: 0,
                    },
                },
            }}
        >
            <div onClick={() => handleOnClick(imageBase64String)} className="icon-container">
                {getDeliveryImageIcon(scanImageStatus, hasAccessToAllPictures)}
            </div>
        </Tooltip>
    );
};
